import {Pipe, PipeTransform} from '@angular/core';
import dayjs from "dayjs";

@Pipe({
    name: 'datePtbr',
    standalone: true
})
export class DatePtbrPipe implements PipeTransform {

    transform(value: string | Date | null | undefined): string {
        if (!value) return 'N/A';

        const date = dayjs(value).locale('pt-br');

        if (!date.isValid()) return 'N/A';

        return date.format('DD/MM/YYYY');
    }

}